import { Amount, asAmount } from "@goodfill/domain-properties";
import { UserAuthDataBalanceAccount } from "../backendApi/amplifyGraphQl/CustomGetUserData/UserData";
import { PricedBond, PricedBondsMap } from "../bonds/PricedBond";

export type AccountBondHoldingValuation = "bid" | "mid";

export class AccountBondHolding {
  pricedBond: PricedBond;
  bondBalanceAccount: UserAuthDataBalanceAccount;

  constructor(pricedBond: PricedBond, bondBalanceAccount: UserAuthDataBalanceAccount) {
    this.pricedBond = pricedBond;
    this.bondBalanceAccount = bondBalanceAccount;

    Object.freeze(this);
  }

  getBondValue(valuation: AccountBondHoldingValuation): Amount {
    return asAmount(
      this.bondBalanceAccount.balance.mul(
        valuation === "bid"
          ? this.pricedBond.bidPrice
          : this.pricedBond.askPrice.plus(this.pricedBond.bidPrice).div(2),
      ),
    );
  }
}

export function createAccountHoldings(
  pricedBonds: PricedBondsMap,
  bondBalanceAccounts: UserAuthDataBalanceAccount[],
): AccountBondHolding[] {
  return bondBalanceAccounts.reduce<AccountBondHolding[]>((acc, bondBalanceAccount) => {
    const pricedBond = bondBalanceAccount.bondId != null ? pricedBonds.get(bondBalanceAccount.bondId) : undefined;

    if (pricedBond !== undefined) {
      acc.push(new AccountBondHolding(pricedBond, bondBalanceAccount));
    }

    return acc;
  }, []);
}
